import { css } from 'styled-components';
import { Color as PaletteColor } from '../types/palette';
export var scrollBar = function scrollBar(_ref) {
  var palette = _ref.theme.palette;
  return css(["&::-webkit-scrollbar{width:12px;}&::-webkit-scrollbar-thumb{background:", ";border:4px solid ", ";border-radius:99px;height:92px;padding:4px 6px;}"], palette[PaletteColor.BorderPrimaryStateless], palette[PaletteColor.ActiveSecondary]);
};